import { getGlobalConfig } from '../globalConfig';

export async function getApiUrl(): Promise<string> {
  return (await getGlobalConfig()).apiUrl;
}

export async function getWSSUrl(): Promise<string> {
  return (await getGlobalConfig()).wssUrl;
}

export async function getMyInterviewAPIKey(): Promise<string> {
  return (await getGlobalConfig()).myInterviewAPIKey;
}
